import React, { Component, Fragment, createRef } from 'react'
import Modal from '@app/components/ui/modals/Modal'

import SVG from "react-inlinesvg"
import helpIcon from '@icons/help/primary'

class ParticipationInstructionsButton extends Component {
  constructor (props) {
    super(props)

    this.modal = createRef(null)

    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleInstructionsCallback = this.handleInstructionsCallback.bind(this)

    this.state = { modalOpened: false }
  }

  handleClick(e) {
    this.setState(() => { return {...this.state, modalOpened: true} })
    this.modal.current.open()
    return false
  }

  handleClose(e) {
    this.setState(() => { return {...this.state, modalOpened: false} })
    this.modal.current.close()
    return false
  }

  handleInstructionsCallback(name, e) {
    const { callback } = this.props

    this.modal.current.close()
    if (callback) { callback(name, e); }

    return true
  }

  renderContent() {
    const { modalOpened } = this.state;
    if (!modalOpened) { return null; }

    const { Component, ...props } = this.props;

    return (
      <Fragment>
        <h1 className="modal__title text-center">
          { I18n.t("instructions.title") }
        </h1>
        <Component {...props} callback={this.handleInstructionsCallback} />
        <div className="w-flex-layout w-flex-layout--columns mt-gutter-l">
          <a href="javascript:void(0)" onClick={this.handleClose} className="btn btn--light-blue f--upper">
            { I18n.t('browser_not_supported.close') }
          </a>
        </div>
      </Fragment>
    )
  }

  render() {
    const { children } = this.props;

    return (
      <Fragment>
        <a
          onClick={this.handleClick}
          className="link link--icon-left f--upper"
        >
          { children ? children : (
              <Fragment>
                <SVG src={helpIcon} />
                { I18n.t("instructions.title") }
              </Fragment>
            )
          }
        </a>
        <Modal ref={this.modal} className="modal--md">
          { this.renderContent() }
        </Modal>
      </Fragment>
    )
  }
}

export default ParticipationInstructionsButton;
